export default __webpack_public_path__ + "static/B0003-dac7bc97c81dfea8c4fb15c0010780de.png";